module.exports = "predecessor"